<template>
  <label
    class="input-field"
    :for=id
  >
    <span
      v-if="props.labelText"
    >
      {{ props.labelText }}<sup v-if="props.required" class="input-filed__red-star">*</sup>
    </span>
    <div class="input-field__input-wrapper">
      <i
        v-if="props.icon"
        class="input-field__icon"
        :style="{
          background: `url(/images/${props.icon}.png) no-repeat center / cover`
        }"
      ></i>
      <input
        class="input-field__input"
        :class="{
          'input-field__input_icon': props.icon,
          'input-field__input_error': props.errors && props.errors.length,
        }"
        :type="props.type ? props.type : 'text'"
        :disabled="props.disabled"
        :id="id"
        :placeholder="props.placeholder"
        :required="props.required"
        v-model="inputValue"
        @input="onInput"
      >
    </div>
    <span
      v-if="props.help"
      class="input-field__help"
    >{{ props.help }}</span>
    <div
      v-if="props.errors && props.errors.length"
      class="input-field__errors"
    >
      <p
        v-for="(error, index) in props.errors"
        :key="error + index + Math.random()"
      >
        {{ error }}
      </p>
    </div>
  </label>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
  labelText: String,
  placeholder: String,
  disabled: Boolean,
  value: String,
  help: String,
  icon: String,
  type: String,
  required: Boolean,
  errors: { Array, default: null },
  debounceWait: { type: Number, default: 1500 },
});

const emit = defineEmits(['input']);

const id = Date.now() + Math.random();
const inputValue = ref(props.value);

const debounce = (func, wait, immediate) => {
  let timeout;

  return function (...args) {
    const context = this;
    clearTimeout(timeout);

    if (immediate && !timeout) func.apply(context, args);

    timeout = setTimeout(() => {
      timeout = null;
      if (!immediate) func.apply(context, args);
    }, wait);
  };
};

const onInput = debounce(() => {
  emit('input', inputValue.value);
}, props.debounceWait);
</script>

<style lang="scss" scoped>
@import '@/assets/scss/input.scss';
</style>
